var $9a7dcb914b29cd9f$exports = {};
$9a7dcb914b29cd9f$exports = {
    "close": `\u{417}\u{430}\u{43A}\u{440}\u{44B}\u{442}\u{44C}`,
    "notifications": `\u{423}\u{432}\u{435}\u{434}\u{43E}\u{43C}\u{43B}\u{435}\u{43D}\u{438}\u{44F}`
};


export {$9a7dcb914b29cd9f$exports as default};
//# sourceMappingURL=ru-RU.mjs.map
